import {hideLoader, showLoader} from "./preloader";
import {GetURLParameter} from "./helpers";
import {setupNextStep} from "../main_form";

function lenderPickerPrepare(res) {
  function pushLPI() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "lenderPickerInited",
      "lead_id": res.lead_id
    })
  }

  pushLPI()
  setupNextStep(["lender-picker"], res.lead_id)
  return true
}

function addLenderPickerHandlers() {
  window.lenderPickerExcluded = []
  let notAllShowed = true
  $('.form-step__banks-item').on('click', function () {
    if (window.lenderPickerBlocked) return
    window.lenderPickerBlocked = true
    let offer = $(this)
    let offerId = offer.find('span').text()
    if (window.lenderPickerOffers.length > window.lenderPickerExcluded.length + window.lenderPickerOptions.count && notAllShowed && window.lenderPickerOptions.replace) {
      offer.addClass('active')
      window.lenderPickerExcluded.push(offerId)
      offer.fadeOut('slow', function () {
        offer.removeClass('active')
        let nextOffer = window.lenderPickerOffers[window.lenderPickerOptions.count - 1 + window.lenderPickerExcluded.length]
        offer.find('span').text(GetURLParameter('offer_id', nextOffer.link))
        offer.find('img').attr('src', nextOffer.img)
        offer.fadeIn()
        window.lenderPickerBlocked = false
      })
    } else {
      notAllShowed = false
      if (offer.hasClass('active')) {
        offer.removeClass('active')
        window.lenderPickerExcluded.splice(window.lenderPickerExcluded.indexOf(offerId), 1)
      } else {
        offer.addClass('active')
        window.lenderPickerExcluded.push(offerId)
      }
      window.lenderPickerBlocked = false
    }
    console.log(window.lenderPickerExcluded)
  })
}

function renderLenderPicker(country, lead_id) {
  if (['1', '7'].indexOf(country) > -1) {
    window.lenderPickerOptions = {count: 9, replace: false}
  } else {
    window.lenderPickerOptions = {count: 0, replace: false}
    // window.lenderPickerOptions = {count: 9, replace: true}
  }
  showLoader(['', '', '', ''])
  let countriesDict = {
    '1': ['ES', '1e6dfc263bf24ae8bccb1f9a6a9abb7f', '¿En qué entidades financieras ya has solicitado el préstamo?', 'No le vamos a ofrecer estas entidades financieras.', 'Puedes seleccionar varios'],
    '2': ['MX', '10c46b96149949849d5acfcb76a30a84', '¿En qué entidades financieras ya has solicitado el préstamo?', 'No le vamos a ofrecer estas entidades financieras.', 'Puedes seleccionar varios'],
    '3': ['PH', 'f97e2fde0ab444018db25fcbee12ecea', 'In which MFIs have you already submitted an application?', 'Knowing this, we will not offer those MFIs that you yourself know.', 'You can choose several'],
    '4': ['AR', 'cb59a7a16ec244e4addb832a09328aac', '¿En qué entidades financieras ya has solicitado el préstamo?', 'No le vamos a ofrecer estas entidades financieras.', 'Puedes seleccionar varios'],
    '5': ['PE', 'dc3d528ca1ff47b9a21e310fc07d920b', '¿En qué entidades financieras ya has solicitado el préstamo?', 'No le vamos a ofrecer estas entidades financieras.', 'Puedes seleccionar varios'],
    '6': ['CO', '4ce47a3bff4543e4a326acf241b77601', '¿En qué entidades financieras ya has solicitado el préstamo?', 'No le vamos a ofrecer estas entidades financieras.', 'Puedes seleccionar varios'],
    '7': ['UA-UA', 'f31056ca12624d0b8d87d2033f0e42ca', 'В яких компаніях ви вже залишали заявку?', 'Ми не станемо їх вам пропонувати.', 'Можна вибрати кілька.'],
    '8': ['KZ-RU', '2e5cbe39af5e4f9785e4d393897ed212', 'В каких компаниях вы уже оставляли заявку?', 'Мы не станем их вам предлагать.', 'Можно выбрать несколько.'],
    '9': ['VN', '20cf793ec83e4beaa65b67dcf8186fd3', 'Bạn đã nộp đơn đăng ký ở những công ty nào?', 'Chúng tôi sẽ không gợi cho bạn những công ty đó nữa.', 'Có thể chọn nhiều đáp an.']
  }
  if (country === '7' && localStorage.getItem('lang') === 'ru') {
    countriesDict['7'] = ['UA-RU', 'f31056ca12624d0b8d87d2033f0e42ca', 'В каких компаниях вы уже оставляли заявку?', 'Мы не станем их вам предлагать.', 'Можно выбрать несколько.']
  }
  let lenderContainer = `<div class="lender-picker" style="margin-top: -30px">
        <h2 class="form-step__title">${countriesDict[country][2]}</h2>
        <p class="form-step__subtitle">${countriesDict[country][3]}<br>${countriesDict[country][4]}</p>
        <div class="form-step__banks-wrap">
        </div></div>`
  let lenderBlock = function (lender) {
    return `<div class="form-step__banks-item">
            <span style="display: none">${GetURLParameter('offer_id', lender.link)}</span>
            <div class="form-step__banks-item__checked">
            <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24.8px" height="24.8px" viewBox="0 0 24.8 24.8" style="enable-background:new 0 0 24.8 24.8;" xml:space="preserve">
            <style type="text/css">
            .st0{fill:#FFFFFF;}
            </style>
            <g>
            <rect x="-2.1" y="9.4" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.1464 12.4246)" class="st0" width="29.1" height="6"/>
            <rect x="-2.1" y="9.4" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 12.4246 29.9957)" class="st0" width="29.1" height="6"/>
            </g>
            </svg>
            </div>
            <img src="${lender.img}" alt="">
            </div>`
  }
  $.ajax({
    url: `https://sl.crezu.net/sl-feed?lead_id=${countriesDict[country][1]}`,
    type: 'get',
    success: function (data) {
      let sl_lenders = []
      for (let i in data) {
        sl_lenders.push(data[i].toLowerCase())
      }
      $.ajax({
        url: `https://cdn.crezu.net/native/feed_lenders/${countriesDict[country][0]}-new.json`,
        type: 'get',
        success: function (data) {
          hideLoader()
          $(".ui-form__wrapper").append(lenderContainer)
          let lenders = []
          for (let i in sl_lenders) {
            for (let j in data) {
              if (sl_lenders[i] == data[j].name && sl_lenders[i] !== 'flink') {
                lenders.push(data[j])
              }
            }
          }
          window.lenderPickerOffers = lenders
          if (window.lenderPickerOptions.count) lenders = lenders.slice(0, window.lenderPickerOptions.count)
          for (var i in lenders) {
            $(".form-step__banks-wrap").append(lenderBlock(lenders[i]));
          }
          addLenderPickerHandlers()
        }, error(e) {
          hideLoader()
        }
      })
    }, error(e) {
      hideLoader()
    }
  });
}

function lenderPickerLinking(offer_id, show_lender) {
  $.ajax({
    url: backendurl + '/webview/lead',
    type: 'post',
    dataType: 'json',
    data: {
      lead_id: $('#lead_id_input').val(),
      offer_id: offer_id,
      status: show_lender
    },
    success: function (data) {
    }
  })
}

export {
  lenderPickerPrepare,
  renderLenderPicker,
  lenderPickerLinking,
}